import React, { useState } from "react";
import { Menu, Checkbox, Flex, Typography } from "antd";
import CustomButton from "../../../components/CustomButton/Button";
import { formatCategoryName, formatOptionLabel } from '../../../helpers/helpers';

const { SubMenu } = Menu;

const WebFilter = ({
  selectedOptions,
  onOptionChange,
  onSelectAll,
  onClear,
  onApply,
  industryTypes,
  enterprises,
  roi,
  maturity,
  rating
}) => {
  const [expandedCategories, setExpandedCategories] = useState({});

  const filterData = {
    roi: roi?.length > 0 ? roi : [],
    maturity: maturity?.length > 0 ? maturity : [],
    rating: rating?.length > 0 ? rating : [],
    industryTypes: industryTypes?.length > 0 ? industryTypes : [],
    enterprises: enterprises.length > 0 ? enterprises : []
  };
  
  const keyMappings = {
    maturity: { idKey: 'maturityId', labelKey: 'maturityDesc' },
    roi: { idKey: 'roiId', labelKey: 'roiDesc' },
    rating: { idKey: 'ratingId', labelKey: 'ratingDesc' },
    industryTypes: { idKey: 'industryTypeId', labelKey: 'industryTypeName' },
    enterprises: { idKey: 'entId', labelKey: 'entName' },
  };

  const handleSelectAll = (category) => {
    const allOptionIds = filterData[category].map((option) => option[keyMappings[category].idKey]);
    const isAllSelected = selectedOptions[category]?.length === allOptionIds.length;
    onSelectAll(category, isAllSelected ? [] : allOptionIds);
  };

  const toggleCategoryView = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  return (
    <div className="web-filter">
      <Flex justify="space-between" className="filter-header">
        <Flex vertical>
          <Typography style={{ fontWeight: "bold" }}>FILTER BY</Typography>
          <Typography style={{ fontSize: 12 }}>
            {Object.values(selectedOptions).flat().length} selected
          </Typography>
        </Flex>
        <CustomButton
          color="primary"
          variant="text"
          style={{ padding: 5 }}
          onClick={onClear}
        >
          CLEAR ALL
        </CustomButton>
      </Flex>
      
      <Menu mode="inline" style={{ width: '100%' }}>
        {Object.keys(filterData)?.map((category) => {
          const selectedCount = selectedOptions[category]?.length || 0;
          const isExpanded = expandedCategories[category] || false;
          const visibleOptions = isExpanded ? filterData[category] : filterData[category].slice(0, 5);

          return (
            <SubMenu
              key={category}
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>{formatCategoryName(category)}</span>
                  {selectedCount > 0 && (
                    <span style={{ fontSize: '12px', color: '#294DD8', marginLeft: 10 }}>
                      {selectedCount} selected
                    </span>
                  )}
                </div>
              }
            >
              <Menu.Item key={`${category}-select-all`}>
                <Checkbox
                  indeterminate={
                    selectedOptions[category]?.length > 0 &&
                    selectedOptions[category]?.length < filterData[category].length
                  }
                  checked={selectedOptions[category]?.length === filterData[category]?.length}
                  onChange={() => handleSelectAll(category)}
                  style={{ fontWeight: 'bold' }}
                >
                  Select All
                </Checkbox>
              </Menu.Item>

              {visibleOptions.map((option) => (
                <Menu.Item key={option[keyMappings[category].idKey]}>
                  <Checkbox
                    value={option[keyMappings[category].idKey]}
                    checked={selectedOptions[category]?.includes(option[keyMappings[category].idKey])}
                    onChange={(e) =>
                      onOptionChange(
                        category,
                        e.target.checked
                          ? [...selectedOptions[category] || [], option[keyMappings[category].idKey]]
                          : selectedOptions[category].filter(id => id !== option[keyMappings[category].idKey])
                      )
                    }
                  >
                    {formatOptionLabel(category, option[keyMappings[category].labelKey])}
                  </Checkbox>
                </Menu.Item>
              ))}

              {filterData[category].length > 5 && (
                <Menu.Item key={`${category}-view-toggle`}>
                  <CustomButton
                    color="primary"
                    variant="text"
                    style={{ padding: 5 }}
                    onClick={() => toggleCategoryView(category)}
                  >
                    {isExpanded ? 'View Less' : 'View More'}
                  </CustomButton>
                </Menu.Item>
              )}
            </SubMenu>
          );
        })}
      </Menu>

      <div className="web-filter-footer">
        <CustomButton
          color="primary"
          variant="text"
          style={{ padding: 5 }}
          onClick={onApply}
        >
          APPLY
        </CustomButton>
      </div>
    </div>
  );
};

export default WebFilter;
